import styled from 'styled-components';

interface InputProps {
    flexDirection: 'column' | 'row';
    maxColumn: any;
}

export const Container = styled.div<InputProps>`
    /* background: ${(props) => props.theme.colors.spaceCaded}; */
    flex-direction: ${(props) => props.flexDirection};
    align-items: ${(props) =>
        props.flexDirection === 'column' ? 'flex-start' : 'center'};
    position: relative;
    ${(props) => (props.maxColumn ? 'column-count: 2;' : 'display: flex;')}
    .input-radio {
        display: flex;
        align-items: center;
        padding-right: 8px;
        cursor: pointer;
        .radio {
            width: 16px;
            height: 16px;
            box-sizing: border-box;
            border: 1px solid ${(props) => props.theme.colors.silverSand};
            border-radius: 100px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            margin: 0;
            .bullet {
                width: 0px;
                height: 0px;
                border-radius: 100px;
                background: ${(props) => props.theme.colors.skyblue};
                transition: all 0.2s;
                &.active {
                    width: 10px;
                    height: 10px;
                }
            }
        }
        .label {
            padding: 0px 0px;
            font-size: 14px;
            color: ${({theme}) => theme.colors.white};
            height: 40px;
            display: flex;
            align-items: center;
            margin-left: 14px;
        }
    }
`;
